import dynamic from 'next/dynamic';

export const RateList = dynamic(() => import('./RateList').then(module => module.RateList));
